function cookie_exists(name, value) {
    const cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.indexOf(name + '=') === 0) {
            const cookie_value = cookie.substring(name.length + 1);
            if (cookie_value === value) {
                return true;
            }
        }
    }
    return false;
}

document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById('cookies_bar')) {
        const cookies_bar = document.getElementById('cookies_bar');

        if (cookie_exists('blog_alice_cookies', 'continue') == true) {
            cookies_bar.style.display = 'none';
        } else {
            cookies_bar.style.display = 'show';
        }

        const cookie_continue = document.getElementById('cookie_continue');
        cookie_continue.addEventListener('click', function () {
            const expiration_date = new Date();
            expiration_date.setFullYear(expiration_date.getFullYear() + 1);
            document.cookie = 'blog_alice_cookies=continue; expires=' + expiration_date.toUTCString() + '; path=/';

            cookies_bar.style.display = 'none';
        });
    }
});